module.exports = __webpack_public_path__ + "static/media/baby.93839e26.svg";